import { alpha } from '@mui/material';
/**
 * Green colors by number from the lightest to the darkest
 */
export var green01 = '#65fcc7';
export var green02 = '#15d18f';
export var green03 = '#00a66c';
export var green04 = '#007a50';
export var green02opacity20 = alpha(green02, 0.2);
